import { Alert, Typography } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';

/**
 * The mandatory not-advice disclaimer (spec §16; Rod 2026-09-10: "tells them
 * we are not accountants or lawyers ... maybe as a banner on every screen").
 *
 * 🔒 EVERY Kit screen carries it, the same way the app does: in full on the
 * hub, the tools page and every business-half page; as ONE LINE on work-half
 * pages, worded "guidance from GL Plus" because those are our own rules, not
 * tax or legal territory. Legal reviews the exact wording before launch.
 *
 * 🔒 RED with red shading (Rod 2026-09-10): the read-this colour, not the amber
 * used for deadlines and gaps.
 */
export function KitDisclaimer() {
  const { t } = useTranslation();
  return (
    <Alert severity="error" title={t('kit.disclaimer.title')} data-testid="kit-disclaimer" sx={{ mb: 3 }}>
      {t('kit.disclaimer.body')}
    </Alert>
  );
}

/** The one-line form, for work-half category and guide pages. */
export function KitDisclaimerLine() {
  const { t } = useTranslation();
  return (
    <Typography role="note" data-testid="kit-disclaimer-line" sx={{ color: '#B3261E', backgroundColor: '#FCEDEC', borderRadius: 2, px: 1.5, py: 1, fontSize: '13px', fontWeight: 600, mb: 2.5 }}>
      {t('kit.disclaimer.line')}
    </Typography>
  );
}
